<template>
    <settings-page :title="title" :description="description">
        <settings-presets
            :type="type"
            :element-type="elementType"
            :preview-text="previewText"
            :default-classes="defaultClasses"
            @input="onInput"
        />
    </settings-page>
</template>

<script>

import SettingsPage from '@/components/settings/shared/settings-page';
import SettingsPresets from '@/components/settings/preset/settings-presets';

export default {
    name: 'settings-presets-button',
    components: { SettingsPage, SettingsPresets },

    data() {
        return {
            title: 'Button Presets',
            description: 'This is where you define your button presets. A “preset“ is a group of styles that can be be quickly added to a page element.',
            previewText: 'Learn More',

            elementType: 'a-button',
            type: 'button',
            defaultClasses: 'f-relative f-text-center f-text-white f-bg-blue-500 f-text-1 f-rounded-0.5 f-border-2 f-border-solid f-border-blue-600 f-font-default f-leading-normal f-font-semibold f-px-1.5 f-py-0.5',
        };
    },

    methods: {
        onInput(prop, data) {
            this.$emit('input', prop, data);
        },
    },
};
</script>
